var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { schemaElementTypes, SchemaElementTypes, schemaToUiTypeMap, UIElementType, } from "../../interfaces/store/actions/payload/schema/schemaElements";
import { getFallbackReferences, isLiteral } from "./schemaUtils";
import { SuggestedPresentation } from "../../interfaces/store/actions/payload/schema/basicTypeCommon";
export var preprocessSchema = function (schemaElements) {
    var preprocessedSchema = {};
    Object.keys(schemaElements).forEach(function (schemaKey) {
        schemaElementTypes.forEach(function (type) {
            if (type in schemaElements[schemaKey]) {
                preprocessedSchema[schemaKey] = __assign(__assign({ fieldName: schemaKey, schemaType: type, uiType: schemaToUiTypeMap[type] }, schemaElements[schemaKey]), schemaElements[schemaKey][type]);
                delete preprocessedSchema[schemaKey][type];
            }
        });
    });
    return preprocessedSchema;
};
var isTextArea = function (element) { return element.multiline !== undefined; };
var isComboBox = function (element) { return element.allowedValues !== undefined; };
var isMultiSelect = function (element) {
    return !!(element.allowedValues !== undefined && element.multiValue !== undefined);
};
var isRadioButton = function (element) {
    return element.suggestedPresentation === SuggestedPresentation.RADIO;
};
var isSlider = function (element) {
    return element.suggestedPresentation === SuggestedPresentation.SLIDER;
};
var isUploadsConfig = function (element) { return element.mimeTypes !== undefined
    && (element.validationReferences !== undefined || element.minCountReference || element.maxCountReference); };
export var redefineFieldTypes = function (schema) {
    var redefinedSchema = {};
    Object.keys(schema).forEach(function (schemaKey) {
        var element = __assign({}, schema[schemaKey]);
        var fallbackReferences = getFallbackReferences(element);
        if (isTextArea(element)) {
            element.uiType = UIElementType.TEXTAREA;
        }
        if (isComboBox(element)) {
            element.uiType = UIElementType.COMBO;
        }
        if (isMultiSelect(element)) {
            element.uiType = UIElementType.MULTISELECT;
        }
        if (isRadioButton(element)) {
            element.uiType = UIElementType.RADIO;
        }
        if (isSlider(element)) {
            element.uiType = UIElementType.SLIDER;
        }
        if (isLiteral(element)) {
            element.uiType = UIElementType.LITERAL;
        }
        if (fallbackReferences) {
            fallbackReferences.forEach(function (reference) {
                var fallback = redefinedSchema[reference] || schema[reference];
                if (!fallback.refFallbackElements) {
                    fallback.refFallbackElements = {};
                }
                fallback.refFallbackElements[schemaKey] = element;
                redefinedSchema[reference] = fallback;
            });
        }
        redefinedSchema[schemaKey] = element;
    });
    return redefinedSchema;
};
export var determineProps = function (element, parentProps) {
    if (parentProps === void 0) { parentProps = {}; }
    return (element.schemaType === SchemaElementTypes.DECORATION_TYPE && element.hasOwnProperty("readOnly")
        ? __assign({ readOnly: element.readOnly }, parentProps) : __assign({}, parentProps));
};
var resolveUploadsReferences = function (uploadsReferencesData) {
    var refElements = uploadsReferencesData.refElements, item = uploadsReferencesData.item, schema = uploadsReferencesData.schema, props = uploadsReferencesData.props;
    var references = __assign({}, refElements);
    var _a = item, validationReferences = _a.validationReferences, minCountReference = _a.minCountReference, maxCountReference = _a.maxCountReference;
    if (validationReferences) {
        validationReferences.forEach(function (ref) {
            references[ref] = resolveReferences(schema, ref, props);
        });
    }
    if (minCountReference) {
        references[minCountReference] = resolveReferences(schema, minCountReference, props);
    }
    if (maxCountReference) {
        references[maxCountReference] = resolveReferences(schema, maxCountReference, props);
    }
    return references;
};
var isValidSchemaReference = function (key) {
    return (key.endsWith("References")
        || key.endsWith("Reference")
        || ["batchUploads", "uploads"].includes(key));
};
export var resolveReferences = function (schema, reference, parentProps) {
    if (parentProps === void 0) { parentProps = {}; }
    var element = __assign(__assign({}, schema[reference]), parentProps);
    if (Object.values(SchemaElementTypes).includes(element.schemaType)) {
        var props_1 = determineProps(element);
        var refElements_1 = {};
        Object.entries(element).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            if (value !== element.fieldName && isValidSchemaReference(key)) {
                if (typeof value === "string" && schema[value]) {
                    refElements_1[value] = resolveReferences(schema, value, props_1);
                }
                if (Array.isArray(value)) {
                    value.forEach(function (item) {
                        if (item !== element.fieldName && typeof item === "string" && schema[item]) {
                            refElements_1[item] = resolveReferences(schema, item, props_1);
                        }
                        else if (isUploadsConfig(item)) {
                            refElements_1 = resolveUploadsReferences({ refElements: refElements_1, item: item, schema: schema, props: props_1 });
                        }
                    });
                }
            }
        });
        if (Object.keys(refElements_1).length) {
            return __assign(__assign({}, element), { refElements: refElements_1 });
        }
    }
    return element;
};
export var parseSchema = function (schemaElements, reference) {
    var schema = preprocessSchema(schemaElements);
    schema = redefineFieldTypes(schema);
    return resolveReferences(schema, reference);
};
